import { useTranslation } from "react-i18next";
import { Monitor } from "@/shared/ui/icons";

export function MobileGuard() {
  const { t } = useTranslation();
  return (
    <main data-theme="accela-donutwork" className="mobile-guard">
      <div className="mobile-guard-card">
        <span className="mobile-guard-icon">
          <Monitor aria-hidden="true" />
        </span>
        <h1>{t("mobileGuard.title")}</h1>
        <p>{t("mobileGuard.description")}</p>
      </div>
    </main>
  );
}
